import React from "react";
import LinkFy from "@dropDesk/presentation/components/linkify";
import {HighLightHashTag} from "@dropDesk/presentation/components/high_light_hashtag";
import {ContentMessageDescription} from "./styled";
import {observer} from "mobx-react";
import {ChatMessageEntity} from "@dropDesk/domain/entities/messages/message_enums";


const TextMessage = observer((
    {
        useHighLightHashTag,
        message,
        color
    }: {
        useHighLightHashTag?: boolean
        message: ChatMessageEntity
        color: string
    }
) => {

    return (
        <ContentMessageDescription color={color}>
            {!useHighLightHashTag ?
                <LinkFy text={message.getText} color={color}/>
                :
                <HighLightHashTag text={message.getText} fontSize={15} color={color}/>}
        </ContentMessageDescription>
    )
});
export default TextMessage;
